<template>

    <v-container>

        <v-sheet height="2" color="transparent">
            <v-progress-linear indeterminate v-if="loading" color="accent darken-1" height="2"/>
        </v-sheet>

        <v-slide-y-transition>
            <div v-show="!loading">

                <v-card-text class="py-0 mt-4 pt-4">
                    <v-timeline
                            align-top
                            dense
                    >
                        <div class="mt-4"></div>
                        <template v-for="(history, year) in groups">
                            <h1>{{year}}</h1>
                            <template v-for="(item, i) in history">
                                <v-timeline-item
                                        fill-dot
                                        :icon="item.psychological_record && item.psychological_record.session_number > 0 ? 'fa-search' : 'fa-calendar-alt'"
                                        :class="[{'indent': item.psychological_record && item.psychological_record.session_number > 0}]"
                                        :color="currentEvent && item.id === currentEvent.id ? 'accent' : (!item.psychological_record || item.psychological_record.session_number === 0 ? 'secondary' : 'primary')"
                                        :large="!item.psychological_record || item.psychological_record.session_number === 0"
                                >
                                    <v-card flat
                                            :color="!item.psychological_record || item.psychological_record.session_number === 0 ? baseColor : sessionColor"
                                            hover @click="showSummary(item.id)">
                                        <v-card-title class="dark py-1">
                                            <div>
                                                <span class="font-weight-bold">{{item.human_date_time.toUpperCase()}}</span>
                                                <v-chip small>
                                                    <v-icon left class="mr-2" size="16">fa-clock</v-icon>
                                                    {{item.time}}
                                                </v-chip>

                                                <v-tooltip top>
                                                    <template v-slot:activator="{ on }">
                                                        <v-avatar v-on="on" size="25" color="grey darken-2">
                                                            <v-icon size="14" dark>{{item.sub_type_icon}}</v-icon>
                                                        </v-avatar>
                                                    </template>
                                                    <span>{{item.sub_type_description}}</span>
                                                </v-tooltip>


                                                <v-chip v-if="!!item.session_name" small :color="item.session_color"
                                                        dark>
                                                    <v-icon class="mr-2" size="16">fa-calendar-check</v-icon>
                                                    {{item.session_name}}
                                                </v-chip>

                                                <v-chip v-if="item.discharge" small color="success" dark>
                                                    <v-icon left class="mr-2" size="16">fa-check-circle</v-icon>
                                                    Alta
                                                </v-chip>


                                            </div>
                                        </v-card-title>

                                        <v-card-text v-if="item.relationship" class="py-1">
                                            Como <span
                                                class="font-weight-bold">{{item.relationship.toLowerCase()}}</span>
                                            de <b>{{item.client.first_name}} {{item.client.last_name}}</b>
                                        </v-card-text>

                                        <v-card-text class="py-1">
                                            Atendido por: <span class="font-weight-bold">{{item.schedule.specialist.first_name}} {{item.schedule.specialist.last_name}}</span>
                                        </v-card-text>

                                        <v-sheet class="pa-2" v-if="item.anamnesis"
                                                 :color="dark ? 'secondary lighten-2' : 'grey lighten-2'">

                                            <template
                                                    v-if="item.anamnesis.symptoms && item.anamnesis.symptoms.length > 0">
                                                <div class="font-weight-bold mt-1">Síntomas:</div>
                                                <div :class="blockClass">
                                                    <template v-for="symptom in item.anamnesis.symptoms">
                                                        <div class="body-1 ml-1" :key="symptom.id"> -
                                                            {{symptom.description}}, durante {{symptom.duration}}
                                                            {{symptom.duration_unit}}
                                                            <template v-if="symptom.eye">, ojo: {{symptom.eye}}
                                                            </template>
                                                            .
                                                        </div>
                                                    </template>
                                                </div>
                                            </template>

                                            <template
                                                    v-if="item.anamnesis.anamnesis_options && item.anamnesis.anamnesis_options.length > 0">
                                                <div class="font-weight-bold mt-1">Observaciones:</div>
                                                <div :class="blockClass">
                                                    <template v-for="option in item.anamnesis.anamnesis_options">
                                                        <div class="body-1 ml-1" :key="option.id"> -
                                                            {{option.description}}.
                                                        </div>
                                                    </template>
                                                </div>
                                            </template>

                                            <template v-if="item.anamnesis.comment">
                                                <div class="font-weight-bold mt-1">Comentarios:</div>
                                                <div :class="blockClass">
                                                    {{item.anamnesis.comment}}
                                                </div>
                                            </template>

                                            <template v-if="item.diagnoses && item.diagnoses.length > 0">
                                                <div class="font-weight-bold mt-1">Diagnóstico:</div>
                                                <div :class="blockClass">
                                                    <template v-for="diagnosis in item.diagnoses">
                                                        <div class="body-1 ml-1" :key="diagnosis.id"> -
                                                            {{diagnosis.name}}.
                                                        </div>
                                                    </template>
                                                </div>
                                            </template>

                                        </v-sheet>

                                    </v-card>
                                    <v-divider></v-divider>
                                </v-timeline-item>
                            </template>
                        </template>

                    </v-timeline>
                </v-card-text>
            </div>
        </v-slide-y-transition>
        <attention-summary-dialog ref="attentionSummaryDialog"/>
    </v-container>
</template>

<script>
    import {getFakeAvatar} from '@/utils/Common'
    import {getCompanionLabel, getSubTypeLabel, getSubTypeIcon} from '@/utils/ScheduleEvent'
    import {ApiUtils} from '@/utils/ApiUtils'
    import {mapState, mapMutations} from 'vuex'
    import AttentionSummaryDialog from './AttentionSummaryDialog'

    export default {
        components: {AttentionSummaryDialog},
        props: {
            clientId: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                dialog: false,
                loading: false,
                history: [],
                client: null,
                total: 0
            }
        },
        mounted() {
            this.getHistory();
        },
        methods: {
            ...mapMutations(['showSnackBar']),
            getFakeAvatar,
            showSummary(evtId) {
                var vm = this
                const evt = vm.history.find(evt => evt.id === evtId)
                vm.$refs.attentionSummaryDialog.show(evt)
            },
            async getHistory() {
                var vm = this

                vm.client = null
                vm.history = []

                if (vm.loading || !vm.currentProvider) return
                vm.loading = true
                const response = await ApiUtils.makeGet(
                    `providers/${vm.currentProvider.id}/client/${vm.clientId}/attention-history`
                )
                vm.loading = false

                if (!response.ok) {
                    const json = await response.json()
                    vm.showSnackBar(json.message || 'Ha ocurrido un error cargando el historial')
                    return
                }

                const json = await response.json()
                vm.history = json.result.attention_history.data
                vm.total = json.result.attention_history.total

            },
        },
        computed: {
            ...mapState(['currentProvider', 'dark']),
            ...mapState('clientAttention', {
                currentEvent: state => state.currentEvent
            }),
            blockClass() {
                const vm = this
                let baseClass = 'section py-1 pl-2'
                if (vm.dark) {
                    baseClass += ' white--text secondary lighten-2'
                } else {
                    baseClass += ' black--text grey lighten-3'
                }
                return baseClass
            },
            baseColor() {
                const vm = this
                return vm.dark ? 'secondary' : 'grey lighten-3'
            },
            sessionColor() {
                const vm = this
                return vm.dark ? 'grey lighten-2' : 'secondary darken-1'
            },
            groups() {
                var vm = this
                if (vm.history.length === 0) return []
                const years = vm.history.map(evt => vm.$moment(evt.date, 'YYYY').format('YYYY'))
                const groups = [...new Set(years)]

                var all = {}

                for (let year in groups) {
                    all[groups[year]] = vm.history
                        .filter(evt => {
                            return vm.$moment(evt.date, 'YYYY').format('YYYY') === groups[year]
                        }).map(event => {
                            var evt = JSON.parse(JSON.stringify(event))
                            evt.human_date_time = vm.$moment(evt.date).format('ddd') + ', ' +
                                vm.$moment(evt.date).format('D') + ' ' +
                                vm.$moment(evt.date).format('MMMM')
                            evt.time = vm.$moment(evt.time, 'HH:mm:ss').format('HH:mm') + ' hrs.'

                            if (!evt || !evt.anamnesis ||
                                (
                                    evt.anamnesis && evt.anamnesis.symptoms.length === 0 &&
                                    evt.anamnesis.anamnesis_options.length === 0 &&
                                    !evt.anamnesis.comment
                                )

                            ) {
                                evt.anamnesis = null
                            } else {
                                var anamnesis = JSON.parse(JSON.stringify(evt.anamnesis))
                                anamnesis.symptoms = anamnesis.symptoms.map(symptom => {
                                    const eye = symptom.pivot.eye ? (
                                        symptom.pivot.eye === 'left' ? 'izquierdo' :
                                            (symptom.pivot.eye === 'right' ? 'derecho' : 'ambos')
                                    ) : null
                                    return {
                                        description: symptom.description,
                                        duration: symptom.pivot.duration,
                                        duration_unit: vm.durationUnits[symptom.pivot.duration_unit],
                                        eye: eye
                                    }
                                })

                                evt.anamnesis = anamnesis
                            }

                            if (evt.client_relationship) {
                                evt.relationship = getCompanionLabel(evt.client_relationship)
                            } else {
                                evt.relationship = null
                            }

                            evt.sub_type_description = getSubTypeLabel(evt.sub_type)
                            evt.sub_type_icon = getSubTypeIcon(evt.sub_type)

                            if (evt.psychological_record) {
                                evt.discharge = evt.psychological_record.last_session && evt.psychological_record.session_number !== 0
                                evt.session_name = evt.psychological_record.session_number === 0 ? 'Primera cita' :
                                    `Sesión ${evt.psychological_record.session_number}`
                                evt.session_color = evt.psychological_record.session_number === 0 ? 'secondary' : 'primary'
                            }

                            return evt
                        })
                }

                return all

            },
            durationUnits() {
                return {
                    'year': 'año(s)',
                    'month': 'mes(es)',
                    'week': 'semana(s)',
                    'day': 'día(s)',
                    'hour': 'hora(s)'
                }
            },
        }
    }
</script>

<style scoped>

    .indent {
        margin-left: 0
    }

    .total {
        font-family: Roboto, sans-serif;
        font-size: 3em;
        font-weight: 300;
    }
</style>